"use strict";

($dt => {
	
	$dt.blocks['four-col-welcome-cta'] = {
		
		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {
			const selector = container.querySelector('form select');
			const form = container.querySelector('form');
			if (form) {
				selector.addEventListener('change', (e) => {
					e.preventDefault();
					//console.log(selector);
					const href = selector.value;
					if (href && href.length > 0) {
						window.location.href = href;
					}
				});
				form.addEventListener('submit', (e) => {
					e.preventDefault();
					//console.log(selector);
					const href = selector.value;
					if (href && href.length > 0) {
						window.location.href = href;
					}
				});
			}
		}
		
	};
	
})(window.d3_wp_themejs);
